var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChangeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 38"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.6673 6.99998C11.6673 5.71109 11.2118 4.61109 10.3007 3.69998C9.38954 2.78887 8.28954 2.33332 7.00065 2.33332C6.35621 2.33332 5.75621 2.4502 5.20065 2.68398C4.64509 2.91776 4.15621 3.24532 3.73398 3.66665H5.66732V5.66665H0.333984V0.333316H2.33398V2.23332C2.93398 1.65554 3.63398 1.19421 4.43398 0.849316C5.23398 0.504428 6.08954 0.332428 7.00065 0.333316C8.84509 0.333316 10.4175 0.983539 11.718 2.28398C13.0184 3.58443 13.6682 5.15643 13.6673 6.99998H11.6673Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M2.33464 6.99996C2.33464 8.28885 2.79019 9.38885 3.7013 10.3C4.61241 11.2111 5.71241 11.6666 7.0013 11.6666C7.64575 11.6666 8.24575 11.5497 8.8013 11.316C9.35686 11.0822 9.84575 10.7546 10.268 10.3333L8.33464 10.3333L8.33464 8.33329L13.668 8.33329L13.668 13.6666L11.668 13.6666L11.668 11.7666C11.068 12.3444 10.368 12.8057 9.56797 13.1506C8.76797 13.4955 7.91241 13.6675 7.0013 13.6666C5.15686 13.6666 3.58441 13.0164 2.28397 11.716C0.983525 10.4155 0.333747 8.84351 0.334636 6.99996L2.33464 6.99996Z",
    fill: "#F5F5F5"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChangeIcon);
export default __webpack_public_path__ + "static/media/change-icon.78dfb20667af7b7fac30a2443264a6f3.svg";
export { ForwardRef as ReactComponent };